import React, { Component } from 'react'
import './TruckAssetDetails.css'

// let asset_details = []
let temp = []
class TruckAssetsDetails extends Component {
    constructor(props) {
        super(props)

        this.state = {
            asset_details: []
        }
        this.state = {
            selectedIndex: 0
        }
    }


    // componentWillReceiveProps(incomingData) {
    //     asset_details = incomingData.truckAssetDetails.truck_asset_details

    //     let index_number
    //     if (asset_details !== undefined) {
    //         if (asset_details.length !== 0) {
    //             for (index_number = 0; index_number < asset_details.length; index_number++) {
    //                 asset_details[index_number].name = index_number
    //             }
    //         }
    //         else {
    //             asset_details = []
    //         }
    //     }
    // }
    static getDerivedStateFromProps(nextProps, prevState) {
        var asset_details_temp = nextProps.truckAssetDetails.truck_asset_details

        let index_number
        // if (asset_details !== undefined) {
        //     if (asset_details.length !== 0) {
        //         for (index_number = 0; index_number < asset_details.length; index_number++) {
        //             asset_details[index_number].name = index_number
        //         }
        //     }
        //     else {
        //         asset_details = []
        //     }
        // } 

        if (asset_details_temp !== undefined) {
            if (asset_details_temp.length !== 0) {
                for (index_number = 0; index_number < asset_details_temp.length; index_number++) {
                    asset_details_temp[index_number].name = index_number
                }
                return {
                    asset_details: asset_details_temp
                }
            }
            else {
                return {
                    asset_details: []
                }
            }
        }
        else{
            return{
                asset_details:[]
            }
        }

    }
    // componentDidMount(){
    //     document.getElementsByID("test").click();

    // }

    show = (event, index)=> {
        this.setState({
            selectedIndex: index
        });
        var id_name = event.target.id;
        document.getElementById("selfOwned").innerHTML = this.state.asset_details[id_name].self_owned;
        document.getElementById("avgFleet").innerHTML = this.state.asset_details[id_name].avg_fleet_age;
        document.getElementById("plannedIncrease").innerHTML = this.state.asset_details[id_name].planned_increase;
        document.getElementById("attachedVehicles").innerHTML = this.state.asset_details[id_name].attached_vehicles;
        document.getElementById("vendor").innerHTML = this.state.asset_details[id_name].vendors;
        document.getElementById("show_name").innerHTML = this.state.asset_details[id_name].type;
    }
    showHighlightedFirst = event => {
        if (temp.length === 0) {
            return (
                <>
                    <div id="variableDataDivision">
                        <div className="row">

                            <div className="col-12 text-center s-asset">
 
                                Asset Details: <b id="show_name">{this.state.asset_details[0].type}</b>

                            </div>
                        </div>

                        <div className="attribute" >
                            <span className="attributeName">Self Owned:  </span><span className="attributeValue" id="selfOwned">{this.state.asset_details[0].self_owned} </span>
                        </div>
                        <div className="attribute" >
                            <span className="attributeName">Average age of Fleet(in years):  </span><span className="attributeValue" id="avgFleet">{this.state.asset_details[0].avg_fleet_age} </span>
                        </div>
                        <div className="attribute" >
                            <span className="attributeName">Planned Increase(next 12 months): </span><span className="attributeValue" id="plannedIncrease">{this.state.asset_details[0].planned_increase} </span>
                        </div>
                        <div className="attribute" >
                            <span className="attributeName">Attached Vehicles: </span><span className="attributeValue" id="attachedVehicles">{this.state.asset_details[0].attached_vehicles} </span>
                        </div>
                        <div className="attribute" >
                            <span className="attributeName">Major Vendors: </span><span className="attributeValue" id="vendor">{this.state.asset_details[0].vendors} </span>
                        </div>



                    </div>  
                </>  
            )


        }
        else {
            return (
                <>
                    <div id="variableDataDivision">
                        <div className="row">

                            <div className="col-12 text-center s-asset">

                                Asset Details: <b id="show_name">{this.state.asset_details[0].type}</b>

                            </div>
                        </div>

                        <div className="attribute" >
                            <span className="attributeName">Self Owned:  </span><span className="attributeValue" id="selfOwned">{this.state.asset_details[0].self_owned}</span>
                        </div>
                        <div className="attribute" >
                            <span className="attributeName">Average age of Fleet(in years):  </span><span className="attributeValue" id="avgFleet">{this.state.asset_details[0].avg_fleet_age} </span>
                        </div>
                        <div className="attribute" >
                            <span className="attributeName">Planned Increase(next 12 months): </span><span className="attributeValue" id="plannedIncrease">{this.state.asset_details[0].planned_increase} </span>
                        </div>
                        <div className="attribute" >
                            <span className="attributeName">Attached Vehicles: </span><span className="attributeValue" id="attachedVehicles">{this.state.asset_details[0].attached_vehicles} </span>
                        </div>
                        <div className="attribute" >
                            <span className="attributeName">Major Vendors: </span><span className="attributeValue" id="vendor">{this.state.asset_details[0].vendors} </span>
                        </div>


                    </div>
                </>
            )
            
        } 
    }

    render() {
        const { asset_details } = this.state
        return (
            <div>
                <h3 className="data_header">Truck / Asset Details</h3>
                {
                    (asset_details === null || asset_details === undefined || asset_details.length === 0) ? (
                        <div>
                            <div className="row">
                                <div className="col-12 text-center">
                                    <h4 className="click_notice">
                                        Click on Truck type to get Asset Details
                                </h4>
                                </div>
                            </div>
                            <p>
                                Details not available
                            </p>
                        </div>
                    ) : (
                        <div className="asset_body">
                            <div className="truckType">
                                <div className="row">
                                    <div className="col-12 text-center s-asset">
                                        Asset Type (Click to see details)
                                        </div>
                                </div>
                                {
                                    asset_details.map((asset, index) =>
                                        // <div className="asset" tabIndex={asset.name} id={asset.name} onClick={this.show} key={index} >
                                        //     {asset.isHighlighted ? (
                                        //         <span id={asset.name} className="assetName"> {asset.type} </span>
                                        //     ) : (
                                        //     <span id={asset.name} className="assetName" > {asset.type} </span>
                                        //         )}


                                        // </div>
                                        

                                        <div key={index}>
                                            {asset.isHighlighted ? (


                                                <div id="test">
                                                    <div className="s-none">
                                                        {temp.push(asset)}
                                                    </div>

                                                    <div className="asset" tabIndex={asset.name} id={asset.name} onClick={this.show} key={index} style={{ backgroundColor: "lightgreen", color: "black" }}>
                                                        <span id={asset.name} className="assetName"> {asset.type} </span>

                                                    </div>
                                                </div>


                                                    ) : ( 
                                                    <div className="asset" tabIndex={asset.name} id={asset.name} onClick={(event) => this.show(event, index)} key={index} style={{ backgroundColor: "white", color: "black", border: index === this.state.selectedIndex ? "2px solid blue" : "none"}}>
                                                <span id={asset.name} className="assetName"> {asset.type} </span>

                                            </div>)}
                                        </div>
                                    )
                                }
                            </div>

                            {/* {console.log(temp)} */}

                            <this.showHighlightedFirst />

                            {/* {temp === [] ? (
                                    <div id="variableDataDivision">
                                        <div className="row">
                                         
                                            <div className="col-12 text-center" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '2%' }}>

                                                Asset Details: <b id="show_name">{asset_details[0].type}</b>

                                            </div>
                                        </div>

                                        <div className="attribute" >
                                            <span className="attributeName">Self Owned:  </span><span className="attributeValue" id="selfOwned">{asset_details[0].self_owned} </span>
                                        </div>
                                        <div className="attribute" >
                                            <span className="attributeName">Average age of Fleet(in years):  </span><span className="attributeValue" id="avgFleet">{asset_details[0].avg_fleet_age} </span>
                                        </div>
                                        <div className="attribute" >
                                            <span className="attributeName">Planned Increase(next 12 months): </span><span className="attributeValue" id="plannedIncrease">{asset_details[0].planned_increase} </span>
                                        </div>
                                        <div className="attribute" >
                                            <span className="attributeName">Attached Vehicles: </span><span className="attributeValue" id="attachedVehicles">{asset_details[0].attached_vehicles} </span>
                                        </div>
                                        <div className="attribute" >
                                            <span className="attributeName">Major Vendors: </span><span className="attributeValue" id="vendor">{asset_details[0].vendors} </span>
                                        </div>

                                     
                                    </div>
                                ) : (
                                        <div id="variableDataDivision">
                                            <div className="row">
                                                
                                                <div className="col-12 text-center" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '2%' }}>

                                                    Asset Details: <b id="show_name">{temp[0].type}</b>

                                                </div>
                                            </div>

                                            <div className="attribute" >
                                                <span className="attributeName">Self Owned:  </span><span className="attributeValue" id="selfOwned">{temp[0].self_owned} </span>
                                            </div>
                                            <div className="attribute" >
                                                <span className="attributeName">Average age of Fleet(in years):  </span><span className="attributeValue" id="avgFleet">{temp[0].avg_fleet_age} </span>
                                            </div>
                                            <div className="attribute" >
                                                <span className="attributeName">Planned Increase(next 12 months): </span><span className="attributeValue" id="plannedIncrease">{temp[0].planned_increase} </span>
                                            </div>
                                            <div className="attribute" >
                                                <span className="attributeName">Attached Vehicles: </span><span className="attributeValue" id="attachedVehicles">{temp[0].attached_vehicles} </span>
                                            </div>
                                            <div className="attribute" >
                                                <span className="attributeName">Major Vendors: </span><span className="attributeValue" id="vendor">{temp[0].vendors} </span>
                                            </div>

                                      
                                        </div>
                                    )} */}



                        </div>
                    )
                }
            </div>
        )
    }
}

export default TruckAssetsDetails
